// extracted by mini-css-extract-plugin
module.exports = {"title":"SysNoticeViewDrawer_title__21Ewv","publisher":"SysNoticeViewDrawer_publisher__2zTox","content":"SysNoticeViewDrawer_content__15_1D"};